import { createCustomOffer } from "./createCustomOffer";
import { fetchOfferData } from "./fetchOfferData";

export const priceFreezeOfferServices = {
  createCustomOffer,
  fetchOfferData,
};
